import React from "react";
import { Bluetooth } from "lucide-react";

import Template from "src/components/app/smart-cale/Template";

const BindingStep: React.FC = () => {
  return (
    <Template
      title="Pairing..."
      titleClassName="text-lg font-semibold text-center mt-4 text-gray-900"
      description={
        <p className="text-sm text-gray-500">
          Connecting to your CGM Reader. Keep the device close.
        </p>
      }
      image={
        <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center animate-pulse">
          <Bluetooth className="w-8 h-8 text-blue-500" />
        </div>
      }
    />
  );
};

export default BindingStep;

